import { Component, OnInit } from '@angular/core';
import { GeneralService } from '@app/core/http';

@Component({
  selector: 'app-unauthorized',
  templateUrl: './unauthorized.component.html',
})
export class UnauthorizedComponent implements OnInit {
  constructor(private generalService: GeneralService) {}

  ngOnInit() {}

  backToMerchant(status: string) {
    this.generalService.backToMerchant(status);
  }
}
